<script lang="ts">
	export let href: string = '/contact#schedule-estimate';
	export let text: String = 'Schedule Estimate';
	export let id: string = undefined;
</script>

<p {id} class="text-center mt-30">
	<a {href} class="btn btn-outline-white btn-square btn-lg btn-default remove-margin">
		{text}
	</a>
</p>
